import { FeeDetails } from "@modules/+new/payments/shared-payments/entities/fee.model";
import { FiatProviderDetailsDto } from "@modules/+new/payments/features/payment-options/infrastructure/dto/fiat-provider-detail.dto";
import { BaseAdapter } from "@modules/+new/payments/shared-payments/entities/base-adapter";

export interface FiatProviderDetails {
	readonly fiatId: number;
	readonly allowedPayoutAccounts: number; // TODO still in use?
	readonly savingsEnabled: boolean;
	readonly vipFeePercentDifference: number;
	readonly informationAvailable: boolean;
	feeDetails: FeeDetails;
}

export class FiatProviderDetailsAdapter extends BaseAdapter<FiatProviderDetailsDto, FiatProviderDetails> {
	public adapt(item: FiatProviderDetailsDto): FiatProviderDetails {
		if (!item) {
			return null;
		}

		return {
			fiatId: Number(item.fiat_id),
			allowedPayoutAccounts: item.allowed_payout_accounts, // TODO still in use?
			savingsEnabled: item.savings_enabled,
			vipFeePercentDifference: Number(item.vip_fee_percent_difference),
			informationAvailable: item.information_available,
			feeDetails: {
				fix: Number(item.fee_fix),
				max: Number(item.fee_max),
				percent: Number(item.fee_percent)
			}
		};
	}
}
